import React from 'react';
import ServicePageLayout from './ServicePageLayout';

const Anxiety = () => (
  <ServicePageLayout
    metaTitle="Evidence-Based Anxiety Therapy & Management | Therapy with Ayesha"
    title="Evidence-Based Anxiety Therapy & Management"
    intro="A structured, CBT-led approach to break the anxiety cycle, regulate your nervous system, and move from constant alarm toward calm emotional mastery."
    badges={['CBT', 'Nervous System Regulation', 'Cognitive Reframing']}
    sections={[
      {
        heading: 'Understanding the Anxiety Cycle',
        body: "Anxiety isn't a flaw — it's a survival system stuck in overdrive. Your brain detects a perceived threat, your body floods with stress hormones, and your thoughts race to scan for danger. The loop reinforces itself: avoidance feels safer in the moment but quietly teaches the brain that the threat was real. The first step in therapy is mapping your unique cycle so we know exactly where to intervene.",
      },
      {
        heading: 'Cognitive Behavioral Therapy (CBT) for Anxiety',
        body: 'CBT is one of the most rigorously researched interventions for anxiety. In our work together, we go beyond surface-level techniques and focus on:',
        points: [
          'Identifying cognitive distortions — catastrophizing, mind-reading, fortune-telling, all-or-nothing thinking — and learning to catch them in real time.',
          'Reframing automatic negative thoughts into balanced, evidence-based ones (not toxic positivity — clarity).',
          'Behavioural experiments to gently test feared outcomes and gather real-world data.',
          'Building exposure tolerance to the situations anxiety has shrunk you away from.',
        ],
      },
      {
        heading: 'Physiological Regulation: Calming the Body',
        body: "Cognitive work alone isn't enough when your body is in fight-or-flight. We integrate practical, evidence-based tools to regulate your nervous system:",
        points: [
          'Paced breathing techniques (e.g., extended exhalation) to activate the parasympathetic system.',
          'Grounding exercises (5-4-3-2-1 sensory) for acute panic and dissociation.',
          'Progressive muscle relaxation for chronic body tension.',
          'Sleep hygiene and circadian rhythm support, since poor sleep amplifies anxiety.',
        ],
      },
      {
        heading: 'From Surviving to Calm Emotional Mastery',
        body: "The goal isn't to never feel anxious again — it's to become unafraid of the anxiety itself. When you trust that you can navigate the feeling without it derailing you, anxiety loses its grip. Over the course of therapy you'll build a personalized toolkit, learn to predict and pre-empt your patterns, and gradually return to the parts of life anxiety had narrowed.",
      },
    ]}
  />
);

export default Anxiety;
